import { Component, OnInit, ViewChild, ElementRef, Input, EventEmitter, Output, Inject, LOCALE_ID } from '@angular/core';
import { Organization } from '@apaq/orgkit-js';
import { StripeService, StripeCardComponent } from 'ngx-stripe';
import {
  StripeCardElementOptions,
  StripeElementsOptions,
  StripeCardElement,
  Token,
  StripeCardElementChangeEvent,
  StripeElementLocale
} from '@stripe/stripe-js';
import { DATA, DIALOG } from 'src/app/modules/dialog/dialog.service';
import { DialogRef } from 'src/app/modules/dialog/dialog-ref';
import { environment } from 'src/environments/environment';

export interface Data {
  organization: Organization;
}

export interface Result {
  token: Token;
}

@Component({
  selector: 'ws-stripe',
  styleUrls: ['stripe.component.scss'],
  templateUrl: 'stripe.component.html'
})
export class StripeComponent {
  @ViewChild(StripeCardComponent) card?: StripeCardComponent;

  organization: Organization;
  loading = false;
  error: any;
  complete = false;
  element?: StripeCardElement;
  cardOptions: StripeCardElementOptions = {
    style: {
      base: {
        iconColor: '#276fd3',
        color: '#31325F',
        lineHeight: '40px',
        fontWeight: 400,
        fontFamily: '-apple-system, system-ui, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: '14px',
        '::placeholder': {
          color: 'rgba(0, 0, 0, 0.65)'
        }
      }
    }
  };

  elementsOptions: StripeElementsOptions

  constructor(private _stripe: StripeService, 
    @Inject(DIALOG) public dialog: DialogRef, @Inject(DATA) private data: Data,
    @Inject(LOCALE_ID) private locale: StripeElementLocale) { 
    this.organization = data.organization;
    this.elementsOptions = {
      locale: this.locale
    };
  }

  onChange(ev: StripeCardElementChangeEvent) {
    if (ev.error) {
      this.error = ev.error.message;
      this.complete = false;
    } else {
      this.error = '';
      this.complete = true;
    }
  }

  async getCardToken() {
    if(!this.card) {
      return;
    }

    this.loading = true;
    const result = await this._stripe.createToken(this.card.element, {
      name: this.organization.name,
      address_line1: this.organization.street ?? 'Unknown address',
      address_line2: '',
      address_city: this.organization.city ?? 'Unknown city',
      address_state: '',
      address_zip: this.organization.postalCode ?? '0000',
      address_country: this.organization.countryCode
    }).toPromise();
    
    this.loading = false;
      // Pass token to service for purchase.
    this.dialog.close(result as Result);

  }
}